import { defineMessages } from "react-intl";

const MY_EBSCO_DATA_REPORTING = "my-ebsco-data-reporting";

const myEbscoDataReportingMessages = defineMessages({
  myEbscoDataReporting: {
    id: `${MY_EBSCO_DATA_REPORTING}.my-ebsco-data-reporting`,
    defaultMessage: "MyEBSCO Data reporting",
    description:
      "Heading for the my ebsco data reporting on data-retention page."
  },
  generateYourReport: {
    id: `${MY_EBSCO_DATA_REPORTING}.generate-your-report`,
    defaultMessage:
      "Generate a report of your MyEBSCO data collected from the past 12 months.",
    description: "Bullet point text to describe user can generate a report"
  },
  requestMyEbscoReport: {
    id: `${MY_EBSCO_DATA_REPORTING}.request-my-ebsco-report`,
    defaultMessage: "Request MyEBSCO report",
    description:
      "Hyperlink for requesting my ebsco report on data-retention page"
  }
});

export default myEbscoDataReportingMessages;
